// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".divider[data-v-4aefa994]{height:0;width:100%;box-shadow:0 0 0 .5px #ccc;opacity:.5}.divider.before[data-v-4aefa994]{margin-top:.5rem}.divider.between[data-v-4aefa994]{margin:.5rem 0}.divider.after[data-v-4aefa994]{margin-bottom:.5rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
